import { BrowserRouter as Router, Routes, Route, Navigate, Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import TickerTape from "./components/TickerTape";
import Home from "./Pages/Home";
import Dashboard from "./Pages/Dashboard";
import Macro from "./Pages/Macro";
import TechnicalAnalysis from "./Pages/TechnicalAnalysis";
import Login from "./Pages/Login";
import AdBanner from "./components/AdBanner";
import MUGapStrategy from "./components/MUGapStrategy";
import BTCQuarterlyReturns from "./components/BTCQuarterlyReturns";
import TATools from "./Pages/TATools";
import Arbitrage from "./Pages/Arbitrage";


function App() {
  const { user } = useAuth();
  const [selectedSymbol, setSelectedSymbol] = useState("BTC/USDT");

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-900 text-white">
        <div className="sticky top-0 z-50">
          <Navbar />
          <TickerTape selected={selectedSymbol} onSelect={setSelectedSymbol} />
        </div>
        <main className="flex-1 p-4 sm:p-6">
          <Routes>
            <Route path="/" element={<Home symbol={selectedSymbol} />} />
            <Route path="/macro" element={<Macro />} />
            <Route path="/ta" element={<TechnicalAnalysis />} />
            <Route path="/ta-tools" element={<TATools />} />
            <Route path="/arbitrage" element={<Arbitrage />} />
            <Route path="/mu-gap" element={<MUGapStrategy />} />
            <Route path="/btc-quarterly" element={<BTCQuarterlyReturns />} />
            <Route
              path="/dashboard"
              element={user ? <Dashboard /> : <Navigate to="/" />}
            />
            <Route path="/login" element={<Login />} />
          </Routes>
        </main>
        <div className="w-full flex justify-center bg-gray-900 px-4">
          <AdBanner slot="1234567890" style={{ display: 'block', width: '100%', height: '90px', maxWidth: '100%' }} />
        </div>
        <footer className="bg-gray-800 text-gray-400 text-sm py-4 px-4 sm:px-6 text-center border-t border-gray-700">
          {!user && (
            <Link to="/login" className="hover:text-gray-300 transition-colors duration-300 underline block sm:inline">
              Login
            </Link>
          )}
          <div className="mt-2 sm:mt-0 sm:ml-4">© 2025 HODL-IT. All rights reserved.</div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
